import moment from "moment";
import { DateFormats } from "../common/Constants";

export interface IDateService {
  formatToLocalTime(date: Date): string;
  formatDate(date: Date): string;
}

const DateService = (): IDateService => {
  return {
    formatToLocalTime(date: Date) {
      return moment(date).format(DateFormats.DATETIME_LOCAL);
    },
    formatDate(date: Date) {
      return moment(date).format(DateFormats.DATE);
    }
  };
};

export { DateService };
